const InvoiceComponent = ({ plan, month }) => {
  return (
    <div className="max-h-screen bg-white font-sans">
      <div className="mx-auto w-full max-w-4xl p-2 sm:p-4 md:p-6 bg-white shadow-lg">
        <img
          src="/images/header3.png"
          alt="Header"
          className="w-full h-auto object-contain mb-6"
        />

        <div className="flex  flex-row justify-between items-start md:items-center mb-4 sm:mb-5 md:mb-6 px-2 sm:px-3 md:px-4">
          <div className="mt-1 sm:mt-3 md:mt-0 text-left md:text-right">
            <p className="text-xs sm:text-sm font-semibold text-gray-900 text-left">
              {`${plan.firstName.charAt(0).toUpperCase()}${plan.firstName.slice(
                1
              )} ${plan.lastName.charAt(0).toUpperCase()}${plan.lastName.slice(
                1
              )}`}
            </p>
            <p className="text-xs sm:text-sm font-semibold text-gray-900 text-left">
              {plan.phoneNumber}
            </p>
            <p className="text-xs sm:text-sm font-semibold text-gray-900 text-left">
              {plan.userEmail}
            </p>
          </div>

          <div className="mt-1 sm:mt-3 md:mt-0 text-left md:text-right">
            <p className="text-xs sm:text-sm font-semibold text-gray-900">
              Invoice No: {plan.invoiceNo}
            </p>
            <p className="text-xs sm:text-sm font-semibold text-gray-900">
              Date: {plan.invoiceDate}
            </p>
          </div>
        </div>

        <div className="w-full">
          <div className="flex flex-row bg-red text-white font-semibold text-[10px] sm:text-xs md:text-sm p-1 sm:p-2 md:p-3">
            <div className="w-[50%]">Description</div>
            <div className="w-[20%] text-center">Months</div>
            <div className="w-[30%] text-center">Price</div>
          </div>

          <div className={`flex flex-row`}>
            <div className="w-[50%] p-1 sm:p-2 md:p-3 border-r-2 border-red">
              <p className="text-[10px] sm:text-xs md:text-sm font-medium text-gray-900">
                {plan.memberShipName} Plan of ({plan.membershipPlanName})
              </p>
              <p className="text-[9px] sm:text-[10px] md:text-xs text-red mt-0.5 sm:mt-1">
                Included
              </p>
              <p className="text-[9px] sm:text-[10px] md:text-xs text-gray-500 mt-0.5 sm:mt-1">
                {plan.benifits || "No benefits specified"}
              </p>
            </div>
            <div className="w-[20%] p-1 sm:p-2 md:p-3 text-center border-r-2 border-red flex items-center justify-center">
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-900">
                {plan.duration} Month
              </p>
            </div>
            <div className="w-[30%] p-1 sm:p-2 md:p-3 text-center flex items-center justify-center">
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-900">
                Rs {plan.amount}
              </p>
            </div>
          </div>

          <div className={`flex flex-row border-red   border-b-4 `}>
            <div className="w-[50%] p-1 sm:p-2 md:p-3 border-r-2 border-red">
              <p className="text-[10px] sm:text-xs md:text-sm font-medium text-gray-900">
                Registration Fee
              </p>
            </div>
            <div className="w-[20%] p-1 sm:p-2 md:p-3 text-center border-r-2 border-red flex items-center justify-center">
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-900"></p>
            </div>
            <div className="w-[30%] p-1 sm:p-2 md:p-3 text-center flex items-center justify-center">
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-900">
                Rs {plan.registrationAmount}
              </p>
            </div>
          </div>

          <div className="flex flex-row justify-between mt-3  sm:mt-4 items-center ">
            <p className="text-xs sm:text-sm md:text-base font-semibold text-gray-900">
              Total Price
            </p>
            <p className="text-xs sm:text-sm md:text-base font-semibold text-gray-900 mt-1 sm:mt-2 md:mt-0">
              {plan.totalPrice}
            </p>
          </div>
        </div>

        <div className="flex flex-row md:flex-row justify-between items-start mt-6 sm:mt-7 md:mt-8 px-2 sm:px-3 md:px-4 gap-3 sm:gap-4">
          <div className="w-full md:w-1/3 text-center md:text-left">
            <img
              src="/images/fitSteakImage.png"
              alt="QR Code 1"
              className="w-16 sm:w-20 md:w-24 mx-auto md:mx-0 mb-1 sm:mb-2"
            />
            <p className="text-[7px] sm:text-xs md:text-xs text-gray-700">
              Plaza 147, Central District, Bahria Orchard Raiwind Road Lahore
            </p>
            <div className="flex justify-center md:justify-start gap-1 sm:gap-2 mt-1 sm:mt-2">
              <a href="https://www.tiktok.com/@fitstreak.official">
                <img
                  src="/images/tiktok.png"
                  alt="TikTok"
                  className="w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6"
                />
              </a>
              <a href="https://www.instagram.com/fitstreak.official">
                <img
                  src="/images/instagram.png"
                  alt="Instagram"
                  className="w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6"
                />
              </a>
              <a href="#">
                <img
                  src="/images/facebook.png"
                  alt="Facebook"
                  className="w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6"
                />
              </a>
              <a href="https://www.threads.net/@fitstreak.official">
                <img
                  src="/images/thread.png"
                  alt="Threads"
                  className="w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6"
                />
              </a>
            </div>
          </div>

          <div className="w-full md:w-1/3 flex flex-col items-center gap-1 sm:gap-2 mt-3 sm:mt-4 md:mt-0">
            <a href="mailto:fitstreak@gmail.com">
              <img
                src="/images/email.png"
                alt="Email"
                className="w-24 sm:w-32 md:w-40 h-auto"
              />
            </a>
            <a href="tel:+92151251241">
              <img
                src="/images/phoneNumber.png"
                alt="Phone"
                className="w-16 sm:w-20 md:w-28 h-auto"
              />
            </a>
            <a href="https://fitstreak.club">
              <img
                src="/images/websitelink.png"
                alt="Website"
                className="w-16 sm:w-20 md:w-28 h-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceComponent;
